module.exports = __webpack_public_path__ + "static/media/dax.1df58358.png";